import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from '@mui/material';
import styled from '@emotion/styled';
import {
  leftDrawerDimen,
  mainAppBarDimen,
  rightDrawerDimen,
  toolBarDimen,
  toPixel,
} from '../styles/dimensions';
import { useMainFrameDispatch, useMainFrameState } from '../MainFrame';
import CloseIcon from '@mui/icons-material/Close';
import { ACTION_CLOSE_RIGHT_FLOATING_DRAWER } from '../constants';

import { DrawerContextProvider } from './DrawerContext';

const toolBarMixin = isToolbarOpen => {
  return {
    ...(isToolbarOpen && {
      marginTop: 0, //toPixel(toolBarDimen.height + mainAppBarDimen.height),
      height: '100vh',
    }),
    ...(!isToolbarOpen && {
      marginTop: toPixel(mainAppBarDimen.height),
      height: `calc(100vh - ${toPixel(mainAppBarDimen.height)})`,
    }),
  };
};

const openMixin = (theme, isToolbarOpen, rightDrawerWidth) => {
  return {
    width: -toPixel(rightDrawerWidth || leftDrawerDimen.open.width),
    '& .MuiDrawer-paper': {
      width: toPixel(rightDrawerWidth || rightDrawerDimen.open.width),
      // width: '500px',
      backgroundColor: theme.palette.rightFloatingDrawerColor,
      ...toolBarMixin(isToolbarOpen),
    },
  };
};

const closeMixin = (theme, isToolbarOpen) => {
  return {
    width: -toPixel(leftDrawerDimen.closed.width),
    '& .MuiDrawer-paper': {
      width: toPixel(rightDrawerDimen.closed.width),
      backgroundColor: theme.palette.rightFloatingDrawerColor,
      ...toolBarMixin(isToolbarOpen),
    },
  };
};

const NVDrawerRight = styled(Drawer, {
  shouldForwardProp: props => true,
})(({ theme, open, isToolbarOpen, rightDrawerWidth }) => {
  return {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && openMixin(theme, isToolbarOpen, rightDrawerWidth)),
    ...(!open && closeMixin(theme, isToolbarOpen)),
  };
});

const NVDrawerRightMain = props => {
  const { isRightDrawerOpen, isToolbarOpen, RightDrawerJsx, rightDrawerWidth } =
    useMainFrameState();

  const dispatch = useMainFrameDispatch();
  const handleClose = () => {
    dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
  };

  return (
    <>
      <NVDrawerRight
        anchor="right"
        open={isRightDrawerOpen}
        onClose={handleClose}
        isToolbarOpen={isToolbarOpen}
        rightDrawerWidth={rightDrawerWidth}
        TransitionComponent={Slide}
        transitionDuration={200}
        // ModalProps={{
        //   style: {
        //     zIndex: 1300
        //   },
        // }}
      >
        {/* <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Eligibility Report
            </Typography>
          </Toolbar>
        </AppBar> */}
        <DrawerContextProvider value={true}>
          <Box
            sx={{
              marginBottom: toPixel(mainAppBarDimen.height),
            }}
          >
            {RightDrawerJsx}
          </Box>
        </DrawerContextProvider>
      </NVDrawerRight>
    </>
  );
};

export default NVDrawerRightMain;
